var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDCoolingDivertingCircuit = function SvgDCoolingDivertingCircuit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Leitungen/L\\xFCftung"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 390,
    width: 40,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 399,
    width: 40,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 392.01,
    width: 40,
    height: 0.97,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 396.01,
    x2: 100,
    y2: 396.01,
    fill: "none",
    stroke: "#437fa3",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 46.01,
    y1: 382,
    x2: 46.01,
    y2: 410,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.04,
    y1: 395.99,
    x2: 46.06,
    y2: 395.99,
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "38.87 382.5 53.15 382.51 46 394.99 38.87 382.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.73,383h12.56s-6.29,10.98-6.29,10.98l-6.27-10.98M38.01,382l7.99,14,8.02-13.99h-16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "47 396 59.5 388.87 59.49 403.15 47 396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,389.74v12.55s-10.99-6.29-10.99-6.29l10.99-6.27M60,388.01l-14,7.99,13.99,8.01v-16h.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "38.86 409.5 46 397.01 53.15 409.5 38.86 409.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,398.01l6.29,10.99h-12.56l6.27-10.99M46,396l-8,14h16.01l-8.02-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25,406.5c-5.79,0-10.5-4.71-10.5-10.5s4.71-10.5,10.5-10.5,10.5,4.71,10.5,10.5-4.71,10.5-10.5,10.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,386c5.52,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M25,385c-6.08,0-11,4.92-11,11s4.93,11,11,11,11-4.92,11-11-4.93-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.36,392.65l1.64,4.36,1.64-4.36h1.28v5.69h-.98v-1.88l.1-2.51-1.68,4.38h-.71l-1.68-4.38.1,2.5v1.88h-.98v-5.69h1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74,439.5c-7.44,0-13.5-6.06-13.5-13.5s6.06-13.5,13.5-13.5,13.5,6.06,13.5,13.5-6.06,13.5-13.5,13.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,413c7.17,0,13,5.83,13,13s-5.83,13-13,13-13-5.83-13-13,5.83-13,13-13M74,412c-7.73,0-14,6.27-14,14s6.27,14,14,14,14-6.27,14-14-6.27-14-14-14h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.71,426.5c.13,0,.26-.05.36-.15l13.15-13.5c.19-.2.19-.51,0-.71-.2-.19-.52-.19-.71,0l-13.15,13.5c-.19.2-.19.51,0,.71.1.09.22.14.35.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.86,440c.13,0,.25-.05.35-.14.2-.19.2-.51,0-.71l-13.15-13.5c-.19-.2-.51-.2-.71,0-.2.19-.2.51,0,.71l13.15,13.5c.1.1.23.15.36.15Z"
  })))));
};
export default SvgDCoolingDivertingCircuit;